<div class="full-page-loader-cont">
  <div class="loader"></div>
</div>
